import { ApiClient } from '@macroinsight/shared-api-client';

export const apiClient = new ApiClient();
